// extracted by mini-css-extract-plugin
export default {"container":"rootLayout_container__BwOjg","container__outlet":"rootLayout_container__outlet__invQt","container__outlet__box":"rootLayout_container__outlet__box__DzSWl"};